import { enableMapSet, produce } from 'immer';

import { WatchlistItemResponse } from 'src/data/WatchListApi/WatchlistApi.types';
import { storeFactory } from 'src/stores/storeFactory';

/**
 *
 * Store to manage watchlist
 * Follows Zustand store implementation with Next.JS example here:
 * https://github.com/vercel/next.js/tree/canary/examples/with-zustand
 *
 */
enableMapSet();

export type Watchlist = Map<string, string>;

interface WatchlistStoreStateData {
  watchlist: Watchlist;
}

interface WatchlistStoreStateFunctions {
  getWatchlist: () => Watchlist;
  setWatchlistData: (watchlistItems: WatchlistItemResponse[] | null) => void;
  emptyWatchlist: () => void;
}

const {
  store: watchlistStore,
  StoreProvider: WatchlistStoreProvider,
  useCreateStore: useCreateWatchlistStore,
} = storeFactory<WatchlistStoreStateData, WatchlistStoreStateFunctions>(
  () => {
    const watchlist: Watchlist = new Map<string, string>();

    return {
      watchlist,
    };
  },
  (set, get) => ({
    setWatchlistData: (watchlistItems: WatchlistItemResponse[] | null) => {
      set((state) =>
        produce(state, (draft) => {
          draft.watchlist = new Map<string, string>(watchlistItems!.map((item) => [item.sku, item.created_at]));
        }),
      );
    },
    emptyWatchlist: () => {
      set((state) =>
        produce(state, (draft) => {
          draft.watchlist = new Map<string, string>();
        }),
      );
    },
    getWatchlist: () => produce(get().watchlist, () => {}),
  }),
);

export { useCreateWatchlistStore, watchlistStore, WatchlistStoreProvider };
